import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../api/helpers/request";
import Notification from "../../api/types/Notification";

const markNotificationAsRead = createAsyncThunk(
    'markNotificationAsRead',
    async (notificationId: number) => {
        return await request<Notification[]>('POST', `/api/users/me/notifications/${notificationId}`);
    }
);

export default markNotificationAsRead;
